import React from "react";

export const CAT_LABEL = {
  sliding_folding: "Sliding Folding", double_door: "Double Door", single_door: "Single Door", railing: "Railing",
  arch: "Arch", front_elevation: "Front Elevation", god: "God", muslim: "Muslim", floral: "Floral",
  geometric: "Geometric", animal: "Animal", ladies: "Ladies", name_plate: "Name Plate", other: "Other",
};

export const CategoryChips = ({ d, small }) => {
  const final = d.categories || [];
  const ai = (d.ai_categories || []).filter((a) => a.confidence >= 50);
  const list = final.length ? final.map((k) => ({ key: k })) : ai;
  if (!list.length) return null;
  return (
    <div className="flex flex-wrap gap-1" data-testid="design-cat-chips">
      {list.map((c) => (
        <span key={c.key} className={(small ? "text-[10px] px-1.5 " : "text-xs px-2 ") + "py-0.5 rounded-sm " +
          (final.length ? "bg-orange-500/15 text-orange-200 border border-orange-500/40" : "border border-dashed border-slate-500 text-slate-300")}
          title={final.length ? (d.cat_source === "example" ? "Pakka example" : "Confirmed") : `AI draft ${c.confidence}%`}>
          {CAT_LABEL[c.key] || c.key}{!final.length && c.confidence != null ? ` ${c.confidence}%` : ""}
        </span>
      ))}
    </div>
  );
};

export const CategoryTabs = ({ cats, counts, allCount, selected, setSelected, unique, setUnique, review, setReview, reviewCount }) => {
  const toggle = (k) => { setReview(false); setSelected((s) => (s.includes(k) ? s.filter((x) => x !== k) : [...s, k])); };
  const pill = (on) => "shrink-0 rounded-sm px-3 py-1.5 text-xs font-bold transition-colors border " +
    (on ? "bg-orange-500 text-white border-orange-500" : "bg-slate-900 text-slate-300 border-slate-700 hover:bg-slate-800");
  return (
    <div className="space-y-2">
      <div className="flex gap-1.5 overflow-x-auto pb-1" data-testid="designs-cat-tabs">
        <button type="button" className={pill(!selected.length && !review)} onClick={() => { setSelected([]); setReview(false); }} data-testid="cat-tab-all">
          All <span className="opacity-70">{allCount}</span>
        </button>
        {cats.filter((c) => c.key !== "other").map((c) => (
          <button key={c.key} type="button" className={pill(selected.includes(c.key))} onClick={() => toggle(c.key)} data-testid={`cat-tab-${c.key}`}>
            {c.label} <span className="opacity-70">{counts[c.key] || 0}</span>
          </button>
        ))}
        <button type="button" className={pill(selected.includes("other"))} onClick={() => toggle("other")} data-testid="cat-tab-other">
          Other <span className="opacity-70">{counts.other || 0}</span>
        </button>
        <button type="button" className={pill(review) + (review ? "" : " !text-amber-300")} onClick={() => { setSelected([]); setReview(!review); }} data-testid="cat-tab-review">
          Review <span className="opacity-70">{reviewCount}</span>
        </button>
      </div>
      <label className="inline-flex items-center gap-2 text-xs text-slate-300 cursor-pointer" data-testid="designs-unique-toggle">
        <input type="checkbox" checked={unique} onChange={(e) => setUnique(e.target.checked)} className="accent-orange-500" />
        Unique designs (same design ek baar)
      </label>
    </div>
  );
};
